import { observer } from 'mobx-react-lite';
import cls from 'classnames';

import OpenInNew from '@/assets/icons/icon-open-in-new.svg?react';
import { useStore } from '@/stores/StoreProvider';

import styles from './Video.module.scss';

function Video() {
  const { diamond } = useStore('diamondsStore');

  if (!diamond?.video360) {
    return null;
  }

  return (
    <div className={styles.root}>
      <div className="container">
        <h2 className={styles.title}>360 Video</h2>
      </div>

      {!diamond.video360.inline && (
        <div className="container">
          <div className={styles.link}>
            <a target="_blank" href={diamond.video360.url}>
              <span>{diamond.video360.title}</span>

              <OpenInNew width="20" height="20" />
            </a>
          </div>
        </div>
      )}

      {diamond.video360.inline && (
        <div className={cls('container', styles.fullRotationViewContainer)}>
          <iframe src={diamond.video360.url} allowFullScreen></iframe>
        </div>
      )}
    </div>
  );
}

export default observer(Video);
